import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { BreachPathAppWebComponentSchema } from '../types';

export class BreachPathAppBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<BreachPathAppWebComponentSchema> {
    throw new Error('Not implemented');
  }

  async getBreachPathIssueDataById(issueId: string): Promise<any> {
    throw new Error('Not implemented');
  }
}
